const FETCH_SETTINGS = {
    "method": "GET",
    "mode": "cors",
    "cache": "no-cache",
    "credentials": "include",
    "headers": {
        "Content-Type": "text/html"
    }
}

function fetchContent(storeAPI, DrawerActions, contentPath) {
    return window.fetch(contentPath, FETCH_SETTINGS).then(response => {
        //console.log("[Drawer fetchContent] Fetch Response:\n", response);
        if (response.ok === true) {
            return response.text();
        } else {
            throw new Error(response.statusText);
        }
    }).then(html => {
            //console.log("[CommentsDrawerMiddleware] Fetch Text:\n", html);
            storeAPI.dispatch(DrawerActions.setContent(html));
        },
        error => {
            //console.error("[CommentsDrawerMiddleware] Fetch Error:\n", error);
            storeAPI.dispatch(DrawerActions.setContent(error.toString()));
        });
}

export default fetchContent;